"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a;

var core_1 = require("@material-ui/core");

var Modal_1 = __importDefault(require("@material-ui/core/Modal"));

var styles_1 = require("@material-ui/core/styles");

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react")); // import { ReactComponent as CloseIcon } from "../assets/images/bb8-close.svg";


require("./BB8Modal.scss");

var BB8ModalTypes_1 = require("./BB8ModalTypes");

var styles = function styles(theme) {
  var _a;

  return styles_1.createStyles((_a = {
    circle: {
      alignItems: 'center',
      borderRadius: '50%',
      borderStyle: 'solid',
      borderWidth: 3,
      display: 'flex',
      height: 150,
      justifyContent: 'center',
      width: 150
    }
  }, _a[BB8ModalTypes_1.BB8ModalTypes.Error] = {
    borderColor: theme.palette.error.main
  }, _a.iconWrapper = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: '30px auto',
    width: '100%'
  }, _a[BB8ModalTypes_1.BB8ModalTypes.Info] = {
    borderColor: theme.palette.secondary.dark
  }, _a.paper = {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    position: 'absolute',
    width: theme.spacing.unit * 50
  }, _a[BB8ModalTypes_1.BB8ModalTypes.Success] = {
    borderColor: theme.palette.status.success
  }, _a.svg = {
    height: 86,
    width: 86
  }, _a[BB8ModalTypes_1.BB8ModalTypes.Warning] = {
    borderColor: theme.palette.status.warning
  }, _a));
};

var IconWrapper = function IconWrapper(_a) {
  var children = _a.children,
      classes = _a.classes,
      type = _a.type;
  return react_1.default.createElement("div", {
    className: classes.iconWrapper
  }, react_1.default.createElement("div", {
    className: classnames_1.default(classes.circle, classes[type])
  }, react_1.default.createElement(core_1.SvgIcon, {
    viewBox: "0 0 16 16",
    className: classes.svg
  }, children)));
};

var modalIcons = (_a = {}, _a[BB8ModalTypes_1.BB8ModalTypes.Error] = function (_a) {
  var classes = _a.classes;
  return react_1.default.createElement(IconWrapper, {
    classes: classes,
    type: BB8ModalTypes_1.BB8ModalTypes.Error
  }, react_1.default.createElement("path", {
    d: "M8,8 L2.5,13.5 L8,8 L13.5,13.5 L8,8 Z M8,8 L2.5,2.5 L8,8 L13.5,2.5 L8,8 Z",
    stroke: "#D30E8B",
    strokeWidth: "1",
    fillRule: "nonzero"
  }));
}, _a[BB8ModalTypes_1.BB8ModalTypes.Info] = function (_a) {
  var classes = _a.classes;
  return react_1.default.createElement(IconWrapper, {
    classes: classes,
    type: BB8ModalTypes_1.BB8ModalTypes.Info
  }, react_1.default.createElement("path", {
    d: "M8,8 L2.5,13.5 L8,8 L13.5,13.5 L8,8 Z M8,8 L2.5,2.5 L8,8 L13.5,2.5 L8,8 Z",
    stroke: "#D30E8B",
    strokeWidth: "1",
    fillRule: "nonzero"
  }));
}, _a[BB8ModalTypes_1.BB8ModalTypes.Success] = function (_a) {
  var classes = _a.classes;
  return react_1.default.createElement(IconWrapper, {
    classes: classes,
    type: BB8ModalTypes_1.BB8ModalTypes.Success
  }, react_1.default.createElement("path", {
    style: {
      fill: 'none'
    },
    id: "path3713",
    d: "M 0,-8 H 24 V 16 H 0 Z"
  }), react_1.default.createElement("path", {
    style: {
      fill: '#008000',
      strokeWidth: 0.89599383
    },
    id: "path3715",
    d: "M 5.0175655,11.762402 1.2543914,7.9992295 0,9.2536208 5.0175655,14.271185 15.769493,3.519261 14.515101,2.2648696 Z"
  }));
}, _a[BB8ModalTypes_1.BB8ModalTypes.Warning] = function (_a) {
  var classes = _a.classes;
  return react_1.default.createElement(IconWrapper, {
    classes: classes,
    type: BB8ModalTypes_1.BB8ModalTypes.Warning
  }, react_1.default.createElement("path", {
    d: "M8,8 L2.5,13.5 L8,8 L13.5,13.5 L8,8 Z M8,8 L2.5,2.5 L8,8 L13.5,2.5 L8,8 Z",
    stroke: "#D30E8B",
    strokeWidth: "1",
    fillRule: "nonzero"
  }));
}, _a);

var BB8SimpleModal = function BB8SimpleModal(props) {
  var children = props.children,
      classes = props.classes,
      open = props.open,
      onClose = props.onClose,
      type = props.type,
      size = props.size;
  var Icon = modalIcons[type || 'none'];
  return react_1.default.createElement(Modal_1.default, {
    "aria-labelledby": "bb8-modal-title",
    "aria-describedby": "bb8-modal-description",
    open: open,
    onClose: onClose
  }, react_1.default.createElement("div", {
    className: classnames_1.default(classes.paper, 'modal-content', {
      default: !size || size === BB8ModalTypes_1.BB8ModalSizes.Default,
      medium: size && size === BB8ModalTypes_1.BB8ModalSizes.Medium,
      small: size && size === BB8ModalTypes_1.BB8ModalSizes.Small
    })
  }, react_1.default.createElement(core_1.IconButton, {
    onClick: onClose,
    className: "btn-close-modal"
  }, react_1.default.createElement("svg", {
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    d: "M5.95199981,7.99999974 L0.639999984,2.68799992 C0.383999993,2.43199993 0.128000001,1.91999994 0.128000001,1.53599995 C0.128000001,0.76799998 0.76799998,0.128000001 1.53599995,0.128000001 C1.91999994,0.128000001 2.30399993,0.383999993 2.68799992,0.639999984 L7.99999974,5.95199981 L13.3119996,0.639999984 C13.5679996,0.383999993 13.9519995,0.128000001 14.4639995,0.128000001 C15.2319995,0.128000001 15.8719995,0.76799998 15.8719995,1.53599995 C15.8719995,1.91999994 15.6159995,2.30399993 15.3599995,2.55999992 L9.98399968,7.93599974 L15.4879995,13.4399996 C15.7439995,13.6959996 15.8719995,14.0799995 15.8719995,14.4639995 C15.8719995,15.2319995 15.2319995,15.8719995 14.4639995,15.8719995 C14.0799995,15.8719995 13.6959996,15.7439995 13.4399996,15.4879995 L7.93599974,9.98399968 L2.55999992,15.3599995 C2.30399993,15.7439995 1.91999994,15.8719995 1.53599995,15.8719995 C0.76799998,15.8719995 0.128000001,15.2319995 0.128000001,14.4639995 C0.128000001,14.0799995 0.255999997,13.6959996 0.511999988,13.4399996 L5.95199981,7.99999974 Z",
    id: "path-1"
  })), react_1.default.createElement("g", {
    id: "Visuals",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, react_1.default.createElement("g", {
    id: "Billing---Issuer-details",
    transform: "translate(-1392.000000, -275.000000)"
  }, react_1.default.createElement("g", {
    id: "UI-/-cards-/-details-/-Customer-ID-thin-Copy",
    transform: "translate(0.000000, 242.000000)"
  }, react_1.default.createElement("g", {
    id: "Customer-ID-card"
  }, react_1.default.createElement("g", {
    id: "Group",
    transform: "translate(1281.333333, 29.000000)"
  }, react_1.default.createElement("g", {
    id: "Icon/Close",
    transform: "translate(111.000000, 4.000000)"
  }, react_1.default.createElement("g", {
    id: "Icon-/-lineart-/--functional-secondary-close"
  }, react_1.default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, react_1.default.createElement("use", {
    href: "#path-1"
  })), react_1.default.createElement("use", {
    id: "Combined-Shape",
    fill: "#717272",
    "fill-rule": "nonzero",
    href: "#path-1"
  }), react_1.default.createElement("g", {
    id: "colors/global/Dark-grey",
    mask: "url(#mask-2)",
    fill: "#7C7E80"
  }, react_1.default.createElement("g", {
    transform: "translate(-9.333333, -9.333333)",
    id: "color"
  }, react_1.default.createElement("rect", {
    x: "0",
    y: "0",
    width: "34.6666679",
    height: "34.6666679"
  })))))))))))), Icon ? react_1.default.createElement(Icon, {
    classes: classes
  }) : undefined, react_1.default.Children.map(children, function (child) {
    return child;
  })));
};

var BB8Modal = styles_1.withStyles(styles)(BB8SimpleModal);
exports.default = BB8Modal;